import StoreListings from './store-listings';

export default {
  StoreListings,
};
